import { Routes } from '@angular/router';
import { HomePerfilComponent } from './components/perfil/home-perfil/home-perfil.component';
import { CriarPerfilComponent } from './components/perfil/criar-perfil/criar-perfil.component';
import { HomeControleAcessoComponent } from './components/controle-acesso/home-controle-acesso/home-controle-acesso.component';
import { RegistosComponent } from './components/registos/registos.component';
import { SettingsHubComponent } from './components/settings-hub/settings-hub.component';
import { ListaPeriodoRenovacaoComponent } from './components/periodo-renovacao/lista-periodo-renovacao/lista-periodo-renovacao.component';

export const ConfigurationRoutes: Routes = [
    {
        path: '',
        children: [
            // Landing hub de Configurações — extensível: novas configurações somam-se
            // aqui como novas rotas filhas, sem alterar as existentes.
            {
                path: '',
                component: SettingsHubComponent,
            },
            {
                path: 'perfil',
                children: [
                    {
                        path: '',
                        component: HomePerfilComponent
                    },
                    {
                        path: 'associar-permissoes/:id',
                        component: CriarPerfilComponent,
                    }
                ]
            },
            {
                path: 'controle-acesso',
                component: HomeControleAcessoComponent,
            },
            {
                path: 'registos',
                component: RegistosComponent
            },
            {
                path: 'periodo-renovacao',
                component: ListaPeriodoRenovacaoComponent,
            }
        ],
    },
];
